import { defaultApiInstance } from '@/compositions/api';

export function getSchedule(date) {
  return defaultApiInstance.get(`v1/baseCalendar/${date}`);
}

export function updateSchedule(payload) {
  return defaultApiInstance.put(`v1/baseCalendar/update`, payload);
}
